import { render } from "./MarketModal.vue?vue&type=template&id=c0d2ad5e&scoped=true"
import script from "./MarketModal.vue?vue&type=script&lang=js"
export * from "./MarketModal.vue?vue&type=script&lang=js"

import "./MarketModal.vue?vue&type=style&index=0&id=c0d2ad5e&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c0d2ad5e"],['__file',"src/components/MarketModal.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c0d2ad5e"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c0d2ad5e', __exports__)) {
    api.reload('c0d2ad5e', __exports__)
  }
  
  module.hot.accept("./MarketModal.vue?vue&type=template&id=c0d2ad5e&scoped=true", () => {
    api.rerender('c0d2ad5e', render)
  })

}


export default __exports__